"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoControlButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * VideoControlButton
 * 
 * An element that represents a video control button
 * 
 * @component 
 * @category Molecules
 */
var VideoControlButton = function VideoControlButton(props) {
  var onClick = function onClick(e) {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    className: props.className ? props.className + ' VideoControlButton' : 'VideoControlButton',
    onClick: null,
    icon: null,
    iconSize: null,
    iconColor: null,
    children: null,
    title: null,
    badge: null
  });

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    onClick: onClick
  }), props.icon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: props.icon,
    size: props.iconSize ? props.iconSize : 36,
    color: props.iconColor ? props.iconColor : _atoms.Color.White2
  }), props.children != null && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "video-control-content"
  }, props.children), props.title != null && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "video-control-title"
  }, props.title), props.badge != null && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "video-control-badge"
  }, props.badge));
};

exports.VideoControlButton = VideoControlButton;